import React, { Component } from 'react';
import '../styles.css';
import { HUMAN_VS_ROBOT, HUMAN_VS_HUMAN, OPTIONS_KEY } from '../const';
import { SKILL_PAGE, SIZE_PAGE, HELP_PAGE } from '../../HOME/const';
import { connect } from 'react-redux';
import { selectPlayers, setOptions } from '../REDUX/actions';
import { goToPage } from '../../HOME/REDUX/actions';
import { selectSkill } from '../REDUX/actions';
import { Background } from '../COMPONENTS/Background';
import BackButton from '../COMPONENTS/BackButton';
import Logo from '../ASSETS/TriangulaLogo.png';
import Title from '../ASSETS/Title.png';
import OnePlayerIcon from '../ASSETS/start.one.player.png';
import TwoPlayerIcon from '../ASSETS/start.two.player.png';
import HelpIcon from '../ASSETS/start.help.png';
import { windowSize, dbget } from '../../HOME/utils';
import { selectorClass } from '../logic';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import _ from 'lodash';
import BmgButton from '../../HOME/COMPONENTS/BmgButton';

const HELP = 'HOW TO PLAY';

class StartPage extends Component {
  handleOption = option => e => {
    if (option === HELP) {
      this.props.goToPage(HELP_PAGE);
      return;
    }

    this.props.selectPlayers(option);

    if (option === HUMAN_VS_HUMAN) {
      this.props.selectSkill(undefined);
    }

    this.props.goToPage(option === HUMAN_VS_HUMAN ? SIZE_PAGE : SKILL_PAGE);
  };

  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    dbget(OPTIONS_KEY, options => this.props.setOptions(options));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  render() {
    const { x, y } = windowSize();
    const width = Math.min(x, y) / 7;
    const cls = selectorClass(x, y);
    const icons = [OnePlayerIcon, TwoPlayerIcon, HelpIcon];

    return (
      <div className="page-root">
        <div style={{ position: 'absolute', left: '1%', top: '1%', zIndex: 1 }}>
          <img src={Logo} width={width} alt="Triangula logo" />
          <span style={{ marginLeft: '10px' }}>
            <img src={Title} height={(width * 7) / 9} alt="triangula" />
          </span>
        </div>
        <div className={cls} style={{ backgroundImage: Background }}>
          {_.map([HUMAN_VS_ROBOT, HUMAN_VS_HUMAN, HELP], (op, i) => {
            const flow = x < y ? 'column' : 'row';
            return (
              <div key={op} className="option triangula-option" style={{ gridAutoFlow: flow }} onClick={this.handleOption(op)}>
                <img src={icons[i]} width={60} alt={op} />
                <div style={{ color: 'white', textShadow: '2px 2px black', margin: '10px 20px' }}>
                  {op === HUMAN_VS_ROBOT ? 'ONE-PLAYER' : op === HUMAN_VS_HUMAN ? 'TWO-PLAYER' : op}
                </div>
              </div>
            );
          })}
        </div>
        <BmgButton />
        <BackButton />
        <HomeButton />
      </div>
    );
  }
}

function mapStateToProps({ ta, common }) {
  return { ...ta, ...common };
}

export default connect(
  mapStateToProps,
  { selectPlayers, goToPage, setOptions, selectSkill }
)(StartPage);
